import React, { useEffect, useState } from "react";
import PermissionsGate from "../../../../utils/permissionGate";
function PMCLinkedModulesForm(props) {
  const {
    setAdminModules,
    selectedData,
    allModules,
    moduleType,
    readOnly
  } = props;
  
  const [fields, setFields] = useState([]);
  
  // To get available options for a specific dropdown
  const getAvailableOptions = (currentIndex) => {
    const selectedOptions = fields.filter((field) => field); // Get all selected fields
    return allModules.filter(item => {
      const productId = item.netsuite_product_id?.toString();
      return !selectedOptions.includes(productId) || fields[currentIndex] === productId;
    });
  };
  
  // Handle change in dropdown selection
  function handleSubjectChange(event, idx) {
    let updatedFields = [...fields]; // Copy fields array
    updatedFields[idx] = event.target.value; // Update the value at the specific index
    setFields(updatedFields); // Update the fields state
    
    // Update selected values in adminModules state
    setAdminModules(updatedFields.filter(value => value !== ""));
  }
  
  // Add a new dropdown
  function handleAdd() {
    setFields([...fields, ""]); // Add an empty field to the array
  }
  
  // Remove a dropdown at index i
  function handleRemove(i) {
    const updatedFields = [...fields];
    if (updatedFields.length > 1) {
      updatedFields.splice(i, 1); // Remove the field at index i
      setFields(updatedFields); // Update the fields state
      setAdminModules(updatedFields);
    }else{
      setAdminModules([]);
      setFields([]);
    }
  }
  
  useEffect(() => {
    // Initialize fields with selectedData and set default values
    if (selectedData) {
      let selected = selectedData.split(",");
      setFields(selected); // Set the fields state to the selected values
      setAdminModules(selected);
    }
  }, [selectedData]);
  
  // Function to check if there are available options to select
  const hasAvailableOptions = () => {
    return fields.length < allModules.length;
  };
  
  return (
    <>    
    {allModules && allModules.length > 0 && (      
      <>
      <h5 className="heading-5 mt-30">
      {moduleType === 'redo' ? 'Re-Do Modules' : moduleType === 'transfer' ? 'Transfer Modules' : 
        moduleType === 'Credit' ? 'Credit Modules' : moduleType === 'progression' ? 'Progression Modules' :
        ''}
        </h5>
        
            <div className="mb-2 mt-3">
            <div className="row align-items-center">
            <div className="col-sm-12 mt-2">
            {fields.map((field, idx) => (          
              <div key={idx}>
              <div className="col-sm-10 mt-2" key={idx}>
              <div className="row align-items-center">
              <div className="col-sm-6">
              <PermissionsGate scopes={['RegPMCSelectionEdit']} errorProps={{ disabled: true }}>                
              <select
              className="form-control"
              name={`subjectReSub_[${moduleType}].subject[${idx}]`}
              onChange={(e) => handleSubjectChange(e, idx)}
              value={field || ""}
              disabled={readOnly}
              >
              <option value="">Select</option>
              {getAvailableOptions(idx).map((module, moduleIdx) => (
                <option key={moduleIdx} value={module?.netsuite_product_id}>
                {module?.name} ({module?.Code}) - Semester {module?.term}
                </option>
              ))}
              </select>  
              </PermissionsGate>
              </div>                             
              {(!readOnly) && (
                <div className="col-sm-1">
                <PermissionsGate scopes={['RegPMCSelectionEdit']} errorProps={{ disabled: true }}>
                <button
                className="btn btn-danger rounded-circle"
                title="Delete"
                onClick={() => handleRemove(idx)}
                disabled={readOnly}
                >
                <i className="fal fa-trash-alt"></i>
                </button>
                </PermissionsGate>
                </div>
              )}
              </div>
              </div>
              <br/>   
              </div>         
            ))}
            </div>
            </div>
            {(!readOnly &&hasAvailableOptions()) && (
              <div className="form-group m-0">
                <PermissionsGate scopes={['RegPMCSelectionEdit']} errorProps={{ disabled: true }}>
              <button
              type={"button"}
              className="btn btn-link p-0 btn-additional"
              onClick={() => handleAdd()}
              disabled={readOnly}
              >
              Add additional line item <i className="fal ml-2 fa-plus"></i>
              </button>
              </PermissionsGate>
              </div>
            )}
            </div>
            </>
          )}

          </>
        );
      }
      
      export default PMCLinkedModulesForm;
      